import React from "react";

import { isAuthorized } from "@/utils/authToken";

import { CommonMenu } from "./CommonMenu";
import { PatientMenu } from "./PatientMenu";

export function ProfileMenu(props) {
  if (isAuthorized("user:patient")) {
    return <PatientMenu {...props} />;
  }

  return <CommonMenu {...props} />;
}
